// 名前、コードなど保存
export const INFO_SET = "common/Title/INFO_SET";
export const INFO_RESET = "common/Title/INFO_RESET";
